import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import PageComponent from 'apps/analytics/components/PageComponent';
import {
  getProductFields,
  getProductFieldsPropTypes,
  getCommonFields,
  getSectionFields,
  getFeaturedFields,
  getSubscriptionFields,
} from 'apps/analytics/components/pageComponentFields';

const getComponentId = (sectionId, sku) => `${sectionId}.${sku}`;
const getFopType = (type) => (type || 'FOP_REGULAR');

export default class SubscriptionPageComponent extends PureComponent {
  static propTypes = {
    ...getProductFieldsPropTypes,
    fopType: PropTypes.string,
    fop: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    collectionOrderDetails: PropTypes.object,
    subscription: PropTypes.object,
  };

  render = () => {
    const { fopType, product, fop, section, collectionOrderDetails, subscription } = this.props;
    return product && fop && section && collectionOrderDetails ? (
      <PageComponent id={getComponentId(section.id, product.sku)} type={getFopType(fopType)}>
        {getProductFields(product)}
        {getCommonFields(collectionOrderDetails)}
        {getSectionFields(section, collectionOrderDetails)}
        {getFeaturedFields(fop)}
        {getSubscriptionFields(subscription)}
      </PageComponent>
    ) : null;
  };
}
